import React from 'react';
import PropTypes from 'prop-types';

const CloseIcon = ({ color, size }) => (
<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="25" height="25" rx="12.5" fill="white"/>
<rect x="0.5" y="0.5" width="25" height="25" rx="12.5" stroke="#E2E8F0"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.1672 9.23431C15.4797 9.54673 15.4797 10.0533 15.1672 10.3657L12.5329 13L15.1672 15.6343C15.4797 15.9467 15.4797 16.4533 15.1672 16.7657C14.8548 17.0781 14.3483 17.0781 14.0359 16.7657L10.8359 13.5657C10.5235 13.2533 10.5235 12.7467 10.8359 12.4343L14.0359 9.23431C14.3483 8.9219 14.8548 8.9219 15.1672 9.23431Z" fill="#081021"/>
</svg>
);

CloseIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

CloseIcon.defaultProps = {
  color: 'currentColor',
  size: '30px',
};

export default CloseIcon;
